import { render } from "./IntroSection.vue?vue&type=template&id=68e6d8fe&scoped=true"
import script from "./IntroSection.vue?vue&type=script&lang=js"
export * from "./IntroSection.vue?vue&type=script&lang=js"

import "./IntroSection.vue?vue&type=style&index=0&id=68e6d8fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e6d8fe"]])

export default __exports__